<template>
  <div class="c-home c-main-shadow">
    <div class="c-header-wrap c-flex ac w100">
      <div class="c-search s">
        <v-text-field
          class="c-search-word"
          v-model="searchKey"
          append-icon="search"
          :placeholder="$T('common.search')"
          color="clr-primary"
        ></v-text-field>
      </div>
      <div class="c-btn-add">
        <v-menu bottom left :disabled="isGuest">
          <v-btn :disabled="isGuest" bottom slot="activator" flat icon color="clr-btn">
            <v-icon>mdi-plus</v-icon>
          </v-btn>
          <edit-post-menu-list />
        </v-menu>
      </div>
    </div>

    <div class="c-list">
      <v-list two-line class="c-post-list">
        <template v-for="(post, index) in list">
          <v-divider v-if="index > 0" :key="index"></v-divider>

          <post-list-tile :post="post" @click="onClick" />
        </template>
        <div v-if="nodata" class="c-none">{{ $T('common.no_data') }}</div>
        <tail-loader v-if="filteredList" :srcs="filteredList" :unit="15" v-model="list" />
      </v-list>
    </div>
  </div>
</template>

<script>
import UTILS from '../../utils/utils';
import postPlugin from '../../utils/plugin/postPlugin';
import postListTile from './PostListTile.vue';
import store from '../../store';
import editPostMenuList from './EditPostMenuList.vue';

export default {
  mixins: [postPlugin],
  components: {
    'post-list-tile': postListTile,
    'edit-post-menu-list': editPostMenuList,
  },
  props: ['commonPosts'],
  data: function() {
    return {
      posts: this.commonPosts,
      dialog: {
        news: false,
        file: false,
        schedule: false,
        enquete: false,
        life: false,
      },
      searchKey: '',
      words: '',
      list: [],
    };
  },
  watch: {
    commonPosts(n, o) {
      this.posts = n;
    },
    searchKey(n, o) {
      this.words = fmtSearchWord(n);
    },
  },
  computed: {
    filteredList() {
      return this.posts.filter(post => {
        if (this.curCid && post.community_id != this.curCid) return false;
        var stw = post.stw;
        if (!stw) {
          stw = fmtSearchTgtWord(
            `${cnvl(post.creator_cm_name, '')} ${this.postTitle(post)} ${
              post.content ? post.content.main : ''
            } ${this.getCommunityName(post.community_id)}`
          );
          post.stw = stw;
        }
        return wordMatch(this.words, stw);
      });
    },
    nodata() {
      return this.filteredList.length == 0;
    },
  },
  methods: {
    openCreateMenu() {
      if (!this.isGuest) createDialog = true;
    },
    onClick(post) {
      this.$router.push({ name: 'postDetail', params: { id: this.curCid, pid: post.id } });
    },
  },
};
</script>

<style scoped>
.c-header-wrap {
  position: sticky;
  top: 79px;
  z-index: 5;
  height: 60px;
  background-color: #fff;
  z-index: 5;
  padding-left: 12px;
}
.le-tbs .c-header-wrap {
  position: fixed;
  top: 48px;
  right: 0;
  height: 48px;
}
.c-list {
  padding: 0;
}
.le-tbs .c-list {
  padding-top: 48px;
}
.c-post-list {
  padding: 0;
}
.c-btn-add {
  margin: 0 20px 0 10px;
  transform: translateY(16px);
}
.le-tbs .c-btn-add {
  margin: 0 10px 0 0;
}
.c-btn-add i {
  font-size: 28px;
}
.c-none {
  display: flex;
  align-items: center;
  justify-content: center;
  height: calc(100vh - 300px);
  min-height: 300px;
  width: 100%;
  font-size: 20px;
  color: rgba(0, 0, 0, 0.54);
  text-align: center;
}
.le-tbs .c-none {
  height: calc(100vh - 225px);
}
.c-search-word {
  width: initial !important;
  margin-right: 12px !important;
}
</style>
